<div id="produitForfait-page">
    <div class="cover-photo" style="position: relative; z-index: 3; left: 0; right: 0; height: 200px">
    </div>

    <div id="instance-content" class="extra-light-grey-cfa-languedoc-bg" style="position: relative; z-index: 10;">

        <div class="container white-bg">

            <div style="margin-left: -15px; margin-top: -110px !important; position: absolute; z-index: 12;">
                <h1 *ngIf="!isLoadingPrepaInfo && titre_produit_readable && produit_forfait_info && produit_forfait_info.nom_instance" class="col-12 p-2 bandeau-title entete font-weight-bold" style="display: table">{{titre_produit_readable}} - {{produit_forfait_info.nom_instance}}</h1>
                <h2 *ngIf="!isLoadingPrepaInfo && produit_forfait_info && produit_forfait_info.cible && produit_forfait_info.date_texte" class="col-12 p-2 bandeau-subtitle ligne font-weight-bold">{{produit_forfait_info.cible}}, {{produit_forfait_info.date_texte}}</h2>
            </div>

            <app-contact-candidat *ngIf="produit_forfait_info && produit_forfait_info.page_diplome > 0" [id_instance]="produit_forfait_info.id_instance"></app-contact-candidat>

            <div class="row">
                <div class="col-sm-12 col-lg-9 px-4">

                    <!-- Présentation du cours -->
                    <div *ngIf="!isLoadingPrepaInfo && produit_forfait_info.bloc_desc_html1" class="row mt-5">
                        <p class="text-justify col-12 cfa-languedoc-paragraphe" [innerHTML]="produit_forfait_info.bloc_desc_html1"></p>
                    </div>

                    <!-- Liste des cours -->
                    <div *ngIf="!isLoadingForfait && forfait && forfait.cours" class="ligne my-2">
                        <div class="row black-transparent">
                            <div class="col-6 full-width-if-extra-small pt-2 pl-4 text-color">
                                <p class="large font-weight-bold text-uppercase">Matières de la préparation</p>
                                <div *ngFor="let cours of course_column_1" class="mt-4">
                                    <div class="font-weight-bold" style="display: flex">
                                        <svg class="mt-2 mr-2" width="8px" height="8px" viewBox="0 0 500 500">
                                            <polygon points="0,0 500,0 500,500, 0,500" style="fill:rgba(0,0,0,0.7); stroke-width: 0" />
                                        </svg>
                                        <h2 style="display: inline; margin: 0" class="libelle_cours">{{cours.libelle_complet | uppercase}}</h2>
                                    </div>
                                    <div class="my-1 small justify small-interline" [innerHTML]="cours.commentaire"></div>
                                </div>
                                <div class="hide-if-not-extra-small mt-4" *ngFor="let cours of course_column_2">
                                    <div class="font-weight-bold" style="display: flex">
                                        <svg class="mt-2 mr-2" width="8px" height="8px" viewBox="0 0 500 500">
                                            <polygon points="0,0 500,0 500,500, 0,500" style="fill:rgba(0,0,0,0.5); stroke-width: 0" />
                                        </svg>
                                        <h2 style="display: inline; margin: 0" class="libelle_cours">{{cours.libelle_complet | uppercase}}</h2>
                                    </div>
                                    <div class="my-1 small justify small-interline" [innerHTML]="cours.commentaire"></div>
                                </div>
                            </div>
                            <div class="hide-on-extra-small-only col-6 pt-2 pr-4 bl-2-dotted text-color">
                                <div *ngFor="let cours of course_column_2" class="mt-4">
                                    <div class="font-weight-bold" style="display: flex">
                                        <svg class="mt-2 mr-2" width="8px" height="8px" viewBox="0 0 500 500">
                                            <polygon points="0,0 500,0 500,500, 0,500" style="fill:rgba(0,0,0,0.5); stroke-width: 0" />
                                        </svg>
                                        <h2 style="display: inline; margin: 0" class="libelle_cours">{{cours.libelle_complet | uppercase}}</h2>
                                    </div>
                                    <div class="my-1 small justify small-interline" [innerHTML]="cours.commentaire"></div>
                                </div>
                            </div>
                            <div class="col-6 hide-on-extra-small-only"></div>
                            <div class="col-6 full-width-if-extra-small bl-2-dotted">
                                <div class="text-right">
                                    <svg style="right: 0" class="square-svg-width" viewBox="0 0 500 500">
                                        <polygon points="0,0 0,500 500,500 500,0" style="fill:rgba(255,255,255,0.4); stroke-width: 0" />
                                    </svg>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- Description détaillée -->
                    <div *ngIf="!isLoadingPrepaInfo && produit_forfait_info.bloc_desc_html2" class="row my-2">
                        <p class="text-justify col-12 cfa-languedoc-paragraphe" [innerHTML]="produit_forfait_info.bloc_desc_html2"></p>
                    </div>

                    <!-- Brochure et demande d'informations -->
                    <div *ngIf="produit_forfait_info && produit_forfait_info.page_diplome > 0" class="my-5 text-center">
                        <div class="row">
                            <div *ngIf="!isLoadingPrepaInfo && produit_forfait_info && produit_forfait_info.lien_brochure && produit_forfait_info.lien_brochure !== ''" class="col-12 col-sm-5 offset-md-1 col-md-4 offset-lg-0 col-lg-5 text-center mx-auto mt-1">
                                <a class="bouton-telecharger ombre-clickable ligne col-12" [href]="'https://www.apprentissage-montpellier.education/brochures/' + produit_forfait_info.lien_brochure" target="_blank"> Télécharger la brochure </a>
                            </div>
                            
                            <div *ngIf="nombre_de_places_restantes && nombre_de_places_restantes > 0" class="col-12 col-sm-7 col-md-6 col-lg-7 text-center mx-auto mt-1">
                                <a class="bouton-inscription ombre-clickable entete col-12" [routerLink]="['/candidature', url_instance]"> Demande d'information </a>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="col-sm-12 col-lg-3">
                    <ng-container *ngFor="let pave of paves">
                        <a [href]="pave.url_destination" class="no-underline" [target]="pave.nouvel_onglet === '1' ? '_blank' : '_self'">
                            <div class="mb-4 mt-4 pave ombre-clickable">
                                <div class="pave__haut" [style.backgroundColor]="pave.couleur_fond_haut">
                                    <p class="pave__haut__text" [style.color]="pave.couleur_texte_haut" [innerHTML]="pave.html_div_haut"></p>
                                    <img class="pave__haut__img" [src]="'https://www.apprentissage-montpellier.education/img/paves/' + pave.image_haut_droite">
                                </div>
                                <div class="pave__bas" [style.backgroundColor]="pave.couleur_fond_bas">
                                    <p class="pave__bas__text" [style.color]="pave.couleur_texte_bas" [innerHTML]="pave.html_div_bas"></p>
                                    <img class="pave__bas__img" [src]="'https://www.apprentissage-montpellier.education/img/paves/' + pave.image_bas_droite">
                                </div>
                            </div>
                        </a>
                    </ng-container>

                    <!-- lieux des prepa -->
                    <div *ngIf="!isLoadingPrepaInfo && produit_forfait_info && produit_forfait_info.centres">
                        <div *ngIf="isLoadingCenter" class="text-center">
                            <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                        </div>
    
                        <div *ngIf="!isLoadingCenter && centres && nombre_de_centres>0">
                            <div class="row entete">
                                <div class="col-12 text-right p-0">
                                    <svg style="right: 0" class="square-svg-width" viewBox="0 0 500 500">
                                        <polygon points="0,0 0,500 500,500 500,0" style="fill:rgba(255,255,255,0.4); stroke-width: 0" />
                                    </svg>
                                </div>
                                <h4 *ngIf="centres && centres[0].ville" class="text-center col-12">Lieu{{nombre_de_centres>1? 'x' : ''}} des cours</h4>
                                <div *ngFor="let centre of centres" class="my-2 col-12 col-md-4 col-lg-12">
                                    <a [href]="centre.url_maps" target="_blank" class="clickable">
                                        <div class="text-center entete-reverse py-1">{{centre.titre | uppercase }}</div>
                                        <img [src]="'https://www.apprentissage-montpellier.education/img/centres/' + centre.image_url" class="image-centre" [alt]="centre.libelle_c" [title]="centre.libelle_c">
                                    </a>                                    
                                    <div class="pb-1 small">
                                        <span class="centre-name">{{centre.libelle_c}}</span>
                                        <br>
                                        <a [href]="centre.url_maps" target="_blank" class="clickable maps-url">
                                            <div style="display: flex">
                                                <img class="mr-1" height="25px" [src]="environment.production? 'assets/img/icon-maps.png' : '../../../assets/img/icon-maps.png'" alt="icone carte" title="icone carte">
                                                <span class="mt-2">
                                                    {{centre.adresse}},<br>
                                                    {{centre.code_postal}} {{centre.ville}}
                                                </span>
                                            </div>
                                        </a>
                                        <div *ngFor="let arret of centre.arrets_transports">
                                            <span>{{arret}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Offres d'emploi -->
                    <div *ngIf="offres_emploi?.length > 0" class="row mt-4 offres">
                        <div class="blue-cfa-languedoc-bg offres__header">
                            <p class="offres__header__line1 font-weight-bold">POSTULEZ AUX POSTES</p>
                            <p class="offres__header__line2">Actuellement à pourvoir dans le cadre de cette formation :</p>
                        </div>
                        <ng-container *ngFor="let offre of offres_emploi; let i=index">
                            <a class="no-underline" [routerLink]="['/offres', offre.id_offre_emploi]">
                                <div class="offres__item"  [ngClass]="i%2 === 0 ? 'light-blue-cfa-languedoc-bg' : 'light-blue-2-cfa-languedoc-bg'">
                                    <img src="assets/img/fleche.png" alt="offre" class="offres__item__img">
                                    <span class="offres__item__text">
                                        {{offre.titre_job}}
                                        <ng-container *ngIf="offre.secteur_activite">
                                            en {{offre.secteur_activite}}
                                        </ng-container>
                                        <ng-container *ngIf="offre.quartier || offre.ville">
                                            à {{offre.quartier? offre.quartier : offre.ville}}
                                        </ng-container>
                                    </span>
                                </div>
                            </a>
                        </ng-container>
                        <a class="orange-cfa-languedoc-bg offres__all-button no-underline" [routerLink]="['/offres']">
                            VOIR TOUTES LES OFFRES
                        </a>
                    </div>

                    <!-- Responsable pédagogique -->
                    <div id="prof-prepa" *ngIf="!isLoadingProf && prof && prof.prenom != null && prof.nom != null && prof.profil != null" class="row mt-4 px-2">
                        <div *ngIf="prof">
                            <p class="mb-0 text-color font-weight-bold">Responsable pédagogique</p>
                            <p class="text-color cfa-languedoc-paragraphe">{{prof.prenom}} {{prof.nom}}</p>
                            <div class="mt-3">
                                <img [src]="prof.photo? 'https://www.apprentissage-montpellier.education/img/profs/' + prof.photo : (environment.production? 'assets/img/prof.png' : '../../../assets/img/prof.png')" [alt]="prof.prenom && prof.nom ? prof.prenom + ' ' + prof.nom : 'prof'" [title]="prof.prenom && prof.nom ? prof.prenom + ' ' + prof.nom : 'prof'" class="img-prof mr-3 mb-1">
                                <p class="cfa-languedoc-paragraphe" style="font-size:13px !important">{{prof.profil}}</p>
                            </div>
                        </div>
                    </div>

                    <!-- rdv téléphonique -->
                    <div id="rdv-tel" class="row mt-4 p-2 blue-cfa-languedoc-bg">
                        <a data-toggle="modal" data-target="#rdvModal" class="simple-link row">
                            <p class="dispo">Nous sommes à votre disposition au <span class="font-weight-bold large" style="white-space:nowrap">04 67 52 70 79</span></p>
                            <div class="col-12 text-center">
                                <img class="cfa-languedoc-icon m-auto" src="assets/img/icone-rdv.png" alt="icone rdv" title="icone rdv"> 
                                <span class="cfa-languedoc-phone m-auto">RDV Téléphonique</span>
                            </div>
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>